module.exports = __webpack_public_path__ + "img/Fu9DOn2Sp1166Bpkb2U-xgUqwh6Y.774b1c38.svg";